import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'
import thunk from 'redux-thunk'

import { configureStore } from '@reduxjs/toolkit'

import rootReducer from './reducers'

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, // Disable default immutable state check
      serializableCheck: false, // Disable default serializable state check
    }).concat(thunk, reduxImmutableStateInvariant()),
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development mode
})
